import { render } from "./PortalMainmenuConfigPage.vue?vue&type=template&id=4a67d747&scoped=true"
import script from "./PortalMainmenuConfigPage.vue?vue&type=script&lang=js"
export * from "./PortalMainmenuConfigPage.vue?vue&type=script&lang=js"

import "./PortalMainmenuConfigPage.vue?vue&type=style&index=0&id=4a67d747&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a67d747"]])

export default __exports__